import React, { useState } from 'react';
import DisplaySolutionPopupContent from './DisplaySolutionPopupContent';

const DisplaySolutionPopupButton = ({ onClick, onClose }) => {
  const key = "md:editor:display-solution:shown";
  const [isModalOpen, toggleModal] = useState(false);
  const [notShowTextPopupBtn, setNotShowTextPopupBtn] = useState(localStorage.getItem(key) === 'true');

  const showModal = () => {
    toggleModal(true);
    if (typeof onClick === 'function') {
      onClick();
    }
    setNotShowTextPopupBtn(true);
    localStorage.setItem(key, 'true');
    document.body.classList.add('fixed');
  };

  const closeModal = () => {
    toggleModal(false);
    if (typeof onClose === 'function') {
      onClose();
    }
    document.body.classList.remove('fixed');
  };

  return (
    <>
      <button className="display-solution-popup-button" onClick={showModal}>
        <i className="fi fi-attention-circle" title={i18n.t('solving_display_problems.button_name')}></i>
        { !notShowTextPopupBtn &&
          <span className={"display-solution-popup-button__text"}>{i18n.t('solving_display_problems.button_name')}</span>
        }
      </button>
      {isModalOpen && <DisplaySolutionPopupContent openModal={isModalOpen} closeModal={closeModal} />}
    </>
  );
};

export default DisplaySolutionPopupButton;
